import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import CallIcon from "@mui/icons-material/Call";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import RefreshIcon from '@mui/icons-material/Refresh';

const iconComponents = {
  FilterListOff: FilterListOffIcon,
  CallOutlined: CallOutlinedIcon,
  ZoomIn: ZoomInIcon,
  Call: CallIcon,
  Column: ViewColumnIcon,
  ClearSearch:SearchOffIcon,
  readNote:MarkUnreadChatAltIcon,
  FullScreen:FullscreenIcon,
  FullScreenExit:FullscreenExitIcon,
  LightMode:LightModeIcon,
  DarkMode:DarkModeIcon,
  Refresh:RefreshIcon,
};

export default function MUIDashBoardIcon({
  handleClick,
  iconName,
  fontSize = "30px",
  title = "title",
  style,
  color="#3A36DB",
  disabled = false,
  loading = false,
}) {
  const SelectedIcon = iconComponents[iconName];

  return (
    <Tooltip title={title} m={1} arrow>
      <span>
        <IconButton
          aria-label="delete"
          size="small"
          onClick={handleClick}
          disabled={disabled}
          sx={{ ...style }}
        >
          {loading ? (
            <CircularProgress size={parseInt(fontSize, 10) || 20} sx={{ color }} />
          ) : (
            <SelectedIcon sx={{ fontSize: { fontSize }, color: color }} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
}
